import type { Media, Page } from "@pdfking/renderer"
import type { XOR } from "@pdfking/tfunc"

import type { FilePlottingContext } from "../../tasks/options/TaskPlotOptions"
import type { MetaFile } from "../base/MetaFile"
import type { VirtualFile } from "../VirtualFile"
import type { VirtualFileType } from "../VirtualFileType"
import type { GeneratedFile } from "./GeneratedFile"
import type { RemoteFile } from "./RemoteFile"

// Base properties shared by both variants
type SinglePagePdfBase = {
  readonly enum: VirtualFileType.SINGLE_PAGE_PDF
  readonly content: GeneratedFile | RemoteFile
  readonly page_number: number
  readonly page_count: number
} & Media &
  MetaFile

// Binary variant: source defined, page/context undefined
type BinarySinglePagePdf = {
  readonly source: VirtualFile
  readonly page: undefined
  readonly context: undefined
} & SinglePagePdfBase

// Plotted variant: source undefined, page/context defined
type PlottedSinglePagePdf = {
  readonly source: undefined
  readonly page: Page
  readonly context: FilePlottingContext
} & SinglePagePdfBase

// Mutually exclusive union like Maybe<T>
export type SinglePagePdf = XOR<BinarySinglePagePdf, PlottedSinglePagePdf>
